import { createSelector } from "reselect"
import { isAdministrator } from "Utils/checkAccess"
// UTILS
import { defaultColorPocket } from "Utils/global"

const EMPTY_OBJECT = Object.freeze({})

const businessState = state => state.myBusiness

// Get Users
export const selectBusinessUsers = createSelector([businessState], select => select.users)

export const selectAdminUsers = createSelector([businessState], select => {
  return select?.users?.filter(user => isAdministrator(user))
})

// Get business informations
export const selectBusiness = createSelector(
  [businessState],
  businessState => businessState?.docs || EMPTY_OBJECT
)

export const selectSeparatedRoles = createSelector(
  [businessState],
  fullBusinessInfos => fullBusinessInfos.roles
)
export const selectUserSeparatedRoles = createSelector(
  [businessState],
  fullBusinessInfos => fullBusinessInfos.rolesOfUser
)

export const selectBusinessRoles = createSelector(
  [selectBusiness],
  myBusiness => myBusiness.businessAccess
)

export const selectDictionaryIdRoleNameRole = createSelector(
  [selectBusinessRoles],
  businessRoles => {
    var dictionaryToReturn = {}
    businessRoles?.forEach(businessRole => {
      dictionaryToReturn[businessRole.accessId] = businessRole.accessName
    })
    return dictionaryToReturn
  }
)

//it's better to use BUSINESS_ID from userConnected
export const selectBusinessId = createSelector(
  [selectBusiness],
  myBusiness => myBusiness?._id?.$oid
)

export const selectSideMenuColor = createSelector([businessState], businessState =>
  businessState?.docs?.sideMenu?.useGradientSideMenu
    ? businessState?.docs?.sideMenu?.sideMenuGradientOne || defaultColorPocket
    : businessState?.docs?.sideMenu?.sideMenuColor ||
    businessState?.docs?.sideMenuColor ||
    businessState?.docs?.secondaryColor ||
    defaultColorPocket
)

export const selectPrimaryActionColor = createSelector(
  [businessState],
  businessState => businessState?.docs?.primaryActionColor || defaultColorPocket
)

export const selectSecondaryColor = createSelector(
  [businessState],
  businessState => businessState?.docs?.secondaryColor || "#f6f6f6"
)

export const selectBannerColor = createSelector(
  [businessState],
  businessState => businessState?.docs?.bannerColor || defaultColorPocket
)

export const selectSeparatorColor = createSelector(
  [businessState],
  businessState => businessState?.docs?.separatorColor || "#e5e7eb"
)

export const selectAlternativeActionColor = createSelector(
  [businessState],
  businessState => businessState?.docs?.alternativeActionColor || defaultColorPocket
)

export const selectIllustrationColor = createSelector(
  [businessState],
  businessState => businessState?.docs?.illustrationColor || defaultColorPocket
)

export const selectBusinessLogo = createSelector(
  [businessState],
  businessState => businessState?.docs?.logo
)

export const selectBusinessIsLogoUploaded = createSelector(
  [businessState],
  businessState => businessState?.docs?.isLogoUploaded
)

export const selectLastBusinessLogoUpdate = createSelector(
  [businessState],
  businessState => businessState.logo.lastUpdate
)

export const selectEmailChecked = createSelector(
  [businessState],
  businessState => businessState.emailChecked
)
export const selectEmailAlreadyUsed = createSelector(
  [businessState],
  businessState => businessState.emailAlreadyUsed
)

export const selectBusinessDefaultPaletteId = createSelector(
  [businessState],
  businessState => businessState?.docs?.defaultPalette
)

export const selectBusinessLinkNav = createSelector(
  [businessState],
  businessState => businessState?.linkNavBusiness
)

export const selectBusinessHeader = createSelector(
  [businessState],
  businessState => businessState?.docs?.header
)

export const selectBusinessNavBar = createSelector(
  [businessState],
  businessState => businessState?.docs?.navBar
)

export const selectBusinessSideMenu = createSelector(
  [businessState],
  businessState => businessState?.docs?.sideMenu
)

export const selectBusinessTag = createSelector(
  [businessState],
  businessState => businessState?.docs?.tag
)

// Get keycloak Users
export const selectKeycloakUsers = createSelector([businessState], select => select.usersKeycloak)

// Get Group
export const selectBusinessGroups = createSelector([businessState], select => select.groups)

export const selectMyBusinessGroups = createSelector([businessState], select => select.myGroups)

export const selectGroupById = createSelector([businessState], select => select.group)
